import { Modal } from "antd";
import React from "react";
import img from "../../../../assets/orgAdmin/batch-created-successfully.svg";

function StudentsBulkUploadModal({
  bulkUploadFlag,
  setBulkUploadFlag,
  setCreateBatchFlag,
  setActiveTab,
  bulkUploadRes,
}) {
  return (
    <Modal
      open={bulkUploadFlag}
      //   onCancel={() => setCreatedSuccessFlag(false)}
      closable={false}
      maskClosable={false}
      footer={null}
      width={500}
    >
      <div className="text-center">
        <img src={img} width={260} className="mx-auto" alt="" />
        <p className="text-center mt-2 sub-text-color text-[.9rem]">
          Bulk Id:
          <span className="font-medium"> {bulkUploadRes?.bulkIdentifier}</span>
        </p>
        <p className="mt-1 text-gray-900 font-semibold text-[1.2rem]">
          Bulk Student Account Creation Started!
        </p>

        <p className="mt-2 sub-text-color text-sm max-w-[440px] mx-auto">
          Student data has been uploaded successfully, and account creation is
          currently in progress. You can track the status in the Bulk Upload
          tab.
        </p>
        <div className="mt-5 flex sm:flex-row flex-col gap-x-3 gap-y-2">
          <button
            onClick={() => {
              setBulkUploadFlag(false);
              setCreateBatchFlag(false);
              setActiveTab("2");
            }}
            className="btn-white px-3 py-2 rounded-lg sm:w-1/2 w-full"
          >
            Go back
          </button>
          <button
            onClick={() => {
              setBulkUploadFlag(false);
              setCreateBatchFlag(false);
              setActiveTab("2");
            }}
            className="btn-orange px-3 py-2 rounded-lg sm:w-1/2 w-full"
          >
            View Bulk Upload
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default StudentsBulkUploadModal;
